export default __webpack_public_path__ + "static/media/hero.b2a74dc1.jpeg";